module.exports = __webpack_public_path__ + "img/game1-center.bac29ea0.webp";